import type { EmailType } from './types';
import { pathnameToEmailTextTypeMap, pathnameToEmailTitleTypeMap } from './types';
import { Link, useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AuthPageContainer } from '@/domains/auth/layouts/AuthPageContainer/AuthPageContainer';
import { RootPaths } from '@/routes/paths';
import { AdaptiveButton, Form, Title } from './Email.styles';

export const Email = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const emailTitle = pathnameToEmailTitleTypeMap[pathname as EmailType];
  const emailText = pathnameToEmailTextTypeMap[pathname as EmailType];

  return (
    <AuthPageContainer>
      <Form>
        <Title>
          <Typography data-testid="EmailTitle" variant={isSmallScreen ? 'h5' : 'h2'}>
            {emailTitle}
          </Typography>
          <Typography data-testid="EmailTitleText" variant={isSmallScreen ? 'body2' : 'body1'}>
            {emailText}
          </Typography>
        </Title>
        <Link data-testid="EmailFormLoginLink" to={RootPaths.SIGN_IN} replace>
          <AdaptiveButton data-testid="EmailLoginButton" size="large" width="fluid">
            LOG IN
          </AdaptiveButton>
        </Link>
      </Form>
    </AuthPageContainer>
  );
};
